export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    // height: 600,
    // overflow: 'hidden',
  },
  dialog: {
    minHeight: 600,
  },
};



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskPhotosDialog/styles.js